import React, { useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import { useParams } from "react-router-dom";
import downloadjs from "downloadjs";
import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import html2canvas from "html2canvas";
import { useCallback } from "react";
import IdHash from "@yag/id-hash";
import { useQuery } from "@apollo/client";
import { getLPGNewRegistrationQuery } from "../queries/GetLPGCards";
import PersonIcon from '@mui/icons-material/Person';
import jsPDF from "jspdf"

const GoGas = () => {
  const params = useParams();
  const qr_code = params.qrcode

  const canvasRef = useRef(null)
  const canvasRef2 = useRef(null)
  const elementRef = useRef(null);

  const hasher = new IdHash();
  const decoded = hasher.decode(qr_code)
  console.log(decoded, 'decoded')
  // let rowData = null;

  // if (decoded) {
  const { data } = useQuery(getLPGNewRegistrationQuery, {
    variables: {
      "phone_number": decoded.toString()
    },
    context: {
      headers: {
        "Content-Type": "application/json",
        authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoic3VwZXJhZG1pbiIsImlhdCI6MTY4MDI2MDk1NiwiaHR0cHM6Ly9oYXN1cmEuaW8vand0L2NsYWltcyI6eyJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInN1cGVyYWRtaW4iLCJtZXJjaGFudCJdLCJ4LWhhc3VyYS1kZWZhdWx0LXJvbGUiOiJzdXBlcmFkbWluIiwieC1oYXN1cmEtdXNlci1pZCI6IjEiLCJ4LWhhc3VyYS1tZXJjaGFudC1pZCI6IjEwNjAifX0.idq3fyqbnemJdsq5IrAhBNc2P5iXic4w6TmRp7sRaxM",
      }
    },
  });
  console.log(data, 'data')
  const rowData = data?.gogas_new_registrations?.[0] || null;
  // }

  useEffect(() => {
    const canvas = canvasRef.current
    const canvas2 = canvasRef2.current
    if (!canvas || !canvas2) return
    // const dpi=200
    // const ctx = canvas.getContext("2d");

    // Set up CSS size.
    // canvas.style.width = canvas.style.width || canvas.width + 'px';
    // canvas.style.height = canvas.style.height || canvas.height + 'px';

    // Get size information.
    // const scaleFactor = dpi / 96;
    // const width = parseFloat(canvas.style.width);
    // const height = parseFloat(canvas.style.height);

    // // Backup the canvas contents.
    // const oldScale = canvas.width / width;
    // const backupScale = scaleFactor / oldScale;
    // const backup = canvas.cloneNode(false) as HTMLCanvasElement;
    // backup.getContext('2d')?.drawImage(canvas, 0, 0);

    // Set fixed canvas dimensions with 300 DPI
    const ctx = canvas.getContext('2d');
    if (!ctx) return
    const dpi = 300;
    // Fixed dimensions: 332px width, 208px height
    const widthInches = 332 / 96; // Convert pixels to inches (96 DPI standard)
    const heightInches = 208 / 96;
    canvas.width = widthInches * dpi;
    canvas.height = heightInches * dpi;
    // canvas.width = Math.ceil(canvas.width );
    // canvas.height = Math.ceil(canvas.height * scaleFactor);

    // Redraw the canvas image and scale future draws.
    // ctx.setTransform(canvas.width, 0, 0, canvas.height, 0, 0);
    // ctx.drawImage(canvas, 0, 0);
    // ctx.setTransform(canvas.width, 0, 0, canvas.height, 0, 0);

    // Set fixed canvas2 dimensions with 300 DPI
    const ctx2 = canvas2.getContext('2d')
    if (!ctx2) return
    const dpi2 = 300;
    // Fixed dimensions: 332px width, 208px height
    const widthInches2 = 332 / 96; // Convert pixels to inches (96 DPI standard)
    const heightInches2 = 208 / 96;
    canvas2.width = widthInches2 * dpi2;
    canvas2.height = heightInches2 * dpi2;
    // canvas2.width = Math.ceil(canvas2.width * scaleFactor);
    // canvas2.height = Math.ceil(canvas2.height * scaleFactor);

    // Redraw the canvas image and scale future draws.
    // ctx2.setTransform(canvas2.width, 0, 0, canvas2.height, 0, 0);
    // ctx2.drawImage(canvas2, 0, 0);
    // ctx2.setTransform(canvas2.width, 0, 0, canvas2.height, 0, 0);
    // // Clear the canvas
    // ctx.clearRect(0, 0, canvas.width, canvas.height)
    // ctx2.clearRect(0, 0, canvas2.width, canvas2.height)
    // Create an image element
    const img = new window.Image()
    img.crossOrigin = "Anonymous";
    const img2 = new window.Image()
    img2.crossOrigin = "Anonymous";

    // Set up image loading
    img.onload = () => {
      // Draw the image on canvas
      // You can adjust the positioning and sizing as needed
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      // Optional: Add some text overlay
      ctx.fillStyle = 'black'
      // Scale font size for 300 DPI canvas
      const scaleFactor = dpi / 96; // 300/96 = 3.125
      ctx.font = `bold 36px "calibri", serif`;
      // Helper function to wrap text
      const wrapText = (text, x, y, maxWidth, lineHeight = 20 * scaleFactor) => {
        const words = text.split(' ')
        let line = ''
        let currentY = y

        for (let i = 0; i < words.length; i++) {
          const testLine = line + words[i] + ' '
          const metrics = ctx.measureText(testLine)
          const testWidth = metrics.width

          if (testWidth > maxWidth && i > 0) {
            ctx.fillText(line, x, currentY)
            line = words[i] + ' '
            currentY += lineHeight
          } else {
            line = testLine
          }
        }
        ctx.fillText(line, x, currentY)
        // console.log(currentY, 'currentY')
        return currentY
      }

      // If you have user data, you can display it
      if (rowData?.name) {
        // Position name after "NAME :" label - aligned with dotted line
        wrapText(`${rowData.name}`, 470, 265, 500, 60)
      }
      if (rowData?.vehicle_number) {
        // Position vehicle number after "VEHICLE : NO." label - aligned with dotted line
        wrapText(`${rowData.vehicle_number.split(' ').join('').toUpperCase()}`, 470, 398, 120)
      }
      if (rowData?.phone_number) {
        // Position phone number after "MOBILE : NO." label - aligned with dotted line
        wrapText(`${rowData.phone_number}`, 470, 478, 120)
      }

    }

    img2.onload = () => {
      ctx2.drawImage(img2, 0, 0, canvas2.width, canvas2.height)
    }

    img.onerror = () => {
      // Handle image loading error
      ctx.fillStyle = 'lightgray'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      ctx.fillStyle = 'black'
      ctx.font = '14px Arial'
      ctx.fillText('Image not found', 10, canvas.height / 2)
    }

    img2.onerror = () => {
      ctx2.fillStyle = 'lightgray'
      ctx2.fillRect(0, 0, canvas2.width, canvas2.height)
      ctx2.fillStyle = 'black'
      ctx2.font = '14px Arial'
      ctx2.fillText('Image not found', 10, canvas2.height / 2)
    }


    // Set the image source - you can modify this to use rowData.imageUrl or any other image source
    // For now, using a placeholder image URL
    img.src = "https://extraa-public.s3.ap-south-1.amazonaws.com/user_id-cards/gogas_lpg_front_card.png?" + new Date().getTime()
    img2.src = "https://extraa-public.s3.ap-south-1.amazonaws.com/user_id-cards/gogas_lpg_back_card.png?" + new Date().getTime()

  }, [rowData, decoded])

  const handleDownloadCoupon = useCallback(async () => {
    try {
      const element = document.getElementById('id-card-modal');
      if (!element) {
        console.error("Element not found");
        return;
      }

      // Capture the element as canvas
      const canvas = await html2canvas(element, {
        useCORS: true,
        allowTaint: true,
        scale: 2,
        logging: false,
        backgroundColor: '#ffffff'
      });

      // Convert canvas to image data URL
      const imgData = canvas.toDataURL('image/png');

      // Create PDF
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });

      // Calculate dimensions to fit the image properly
      const imgWidth = 210; // A4 width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Add image to PDF
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

      // Download the PDF
      pdf.save(`${rowData?.phone_number || 'id-card'}-qr-code.pdf`);

    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  }, [rowData]);

  return (
    <>
      <div style={{ maxWidth: "500px", margin: "0 auto" }}>
        {/* <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}> */}
        {/* <div style={{ margin: "10px 10px", padding: "25px", border: "2px solid black", maxWidth: "262px", height: "500px", borderRadius: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
            <img src="https://storage.extraa.in/files/gogas_logo.png" style={{ width: "200px", height: "150px" }}></img> */}
        <div id="id-card-modal" ref={elementRef} style={{
          display: 'flex', flexDirection: 'column',
          justifyContent: 'center', alignItems: 'center',
          padding: 16,
          backgroundColor: 'transparent',
        }}>
          <div style={{ position: "relative", width: 334 }}>
            <canvas
              ref={canvasRef}
              width="332"
              height="208"
              style={{ borderRadius: 12, width: 332, height: 208 }}
            >
            </canvas>
            <canvas
              ref={canvasRef2}
              width="332"
              height="208"
              style={{ borderRadius: 12, width: 332, height: 208 }}
            // style={{ border: "1px solid grey" }}
            ></canvas>
            {rowData?.image_url && (
              <img
                crossOrigin="anonymous"
                src={rowData?.image_url + "?" + new Date().getTime()}
                alt="No image"
                style={{
                  position: "absolute",
                  top: 70,
                  left: 17,
                  width: 72,
                  height: 92,
                  pointerEvents: "none",
                  borderRadius: 8,
                  objectFit: 'cover'// allows clicks to pass through
                }}
              />
            )}
            {!rowData?.image_url && (
              <img
                crossOrigin="anonymous"
                src={"https://storage.extraa.in/files/user_alt.png" + "?" + new Date().getTime()}
                alt="No image"
                style={{
                  position: "absolute",
                  top: 70,
                  left: 17,
                  width: 72,
                  height: 92,
                  pointerEvents: "none",
                  borderRadius: 8,
                  objectFit: 'cover'// allows clicks to pass through
                }}
              />
            )}
            <div className="qr-css" style={{
              // padding: "12px",
              display: "flex",
              justifySelf: "center",
              maxWidth: "fit-content",
              // borderRadius: "20px",
              position: "absolute",
              top: 122,
              right: 28,
            }}>
              <QRCode
                fgColor="#000"
                bgColor="transparent"
                size={50}
                style={{ height: "auto", maxWidth: "500px", width: "100%" }}
                value={"@" + qr_code}
                viewBox={`0 0 256 256`}
                level="H"
              />
            </div>
          </div>
        </div>
        {/* <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}> */}
        <Button
          style={{
            background: "#f6eef9",
            borderRadius: 2,
            color: "#421C4D",
            border: "solid 1px #421C4D",
            textTransform: "capitalize",
          }}
          onClick={handleDownloadCoupon}
          endIcon={<Download />}
        >
          Download
        </Button>
        {/* </div> */}
        {/* </div>
        </div> */}
      </div>
    </>
  );
};

export default GoGas;
